import { useRef, useEffect } from "react";
function useLatest(value) {
  const valueRef = useRef(value);
  useEffect(() => {
    valueRef.current = value;
  });
  return valueRef;
}
export {
  useLatest };
//# sourceMappingURL=dist/lib/hooks/useLatest.js.map